// @ts-strict-ignore
import React, { ChangeEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button, Icon, Input } from '@node-space/ui-components'

type SearchingToolProps = {
  query?: string
  onSearchChanged: (query: string) => void
}

const SearchingTool = ({ onSearchChanged, query }: SearchingToolProps) => {
  const { t } = useTranslation()
  const onQueryChanged = (e: ChangeEvent<HTMLInputElement>) => {
    onSearchChanged(e.currentTarget.value)
  }

  return (
    <Box paddingB={24}>
      <Box width="full" className="relative">
        <Box>
          <Input
            onChange={onQueryChanged}
            searchable={true}
            value={query}
            placeholderText={t('search')}
            iconPosition="right"
            {...(!!query.length && {
              IconButton: (
                <Button
                  type="button"
                  iconElement={<Icon name="X" />}
                  variant="ghost"
                  onClick={() => onSearchChanged('')}
                />
              ),
            })}
          />
        </Box>
      </Box>
    </Box>
  )
}

export default React.memo(SearchingTool)
